import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CardArticleLoading from '../../MiddleContentComponent/components/card-article-loading.component';
import ExternalNewsCardRightComponent from './external-news-card.component';
import { trendingTopicsApi } from '../../../../apis/trending-topics.api';

const TrendingCrossPlatformStory = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [listTrendingStory, setListTrendingStory] = useState([]);

  const handleRedirectViewAllStories = () => {
    navigate('/?tab=newsHub');
  };

  const generateTags = (topic) => {
    const commonWords = [
      'the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of',
      'with', 'by', 'a', 'an', 'is', 'are', 'was', 'were', 'be', 'been',
      'being', 'have', 'has', 'had', 'do', 'does', 'did', 'will', 'would',
      'could', 'should', 'this', 'that', 'these', 'those', 'from', 'into',
      'about', 'over', 'under', 'up', 'down', 'out', 'off', 'again',
      'further', 'then', 'once'
    ];

    const text = `${topic.topic} ${topic.description}`.toLowerCase();
    const words = text.match(/\b\w{4,}\b/g) || [];

    const meaningfulWords = [...new Set(words)]
      .filter((word) => !commonWords.includes(word))
      .filter((word) => !/^\d+$/.test(word))
      .slice(0, 3);

    const categoryTag = topic.category?.toLowerCase();
    if (categoryTag && categoryTag !== 'general' && !meaningfulWords.includes(categoryTag)) {
      meaningfulWords.unshift(categoryTag);
    }

    return meaningfulWords.slice(0, 3);
  };

  useEffect(() => {
    const getBreakingNews = async () => {
      try {
        const result = await trendingTopicsApi.getPublishedTrendingTopics(null, 3);
        if (result) {
          setListTrendingStory(result.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getBreakingNews();
  }, []);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="px-5 pt-5 pb-4 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-growth-green-400 to-growth-green-600 flex items-center justify-center">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67z"/>
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-900">Story Pulse</h2>
          </div>
          {listTrendingStory?.length > 0 && (
            <button
              onClick={handleRedirectViewAllStories}
              className="text-sm font-semibold text-growth-green-600 hover:text-growth-green-700 transition-colors"
            >
              View all
            </button>
          )}
        </div>
        <p className="text-sm text-gray-500 mt-2">
          Under-covered stories waiting for your perspective
        </p>
      </div>

      {/* Content */}
      <div className="px-5 py-4">
        {loading && <CardArticleLoading />}
        
        {!loading && listTrendingStory?.length === 0 && (
          <p className="text-sm text-gray-400 text-center py-6">
            No trending stories right now. Check back later!
          </p>
        )}

        <div className="space-y-0">
          {listTrendingStory?.map((item, index) => {
            const tags = generateTags(item);
            const itemWithTags = { ...item, tags };

            return (
              <div key={item.id || item.topic}>
                <ExternalNewsCardRightComponent item={itemWithTags} />
                {index < listTrendingStory.length - 1 && (
                  <div className="my-5 border-t border-gray-100"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrendingCrossPlatformStory;
